export default function CustomYAxis({x, y, payload, postFix}) {
    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={5} textAnchor="end" fill="#666">{payload.value + " " + postFix}</text>
        </g>
    );
}